import React, { useContext, useEffect, useState, useRef } from "react";
import moment from "moment";
import SidebarContext from "../../contexts/MyContext";
import { AudioHandler } from "../../Apihander/AudioRecording/AudioRecording";
import { successToast, errorToast } from "../../utils/notificationUtils";
import Modal from "../Modal/Modal";
import { Icon } from "@iconify/react";
import { formatTimeWithOptionalHours, durationToSeconds } from "../../utils/timeFile"
import { matchesActionFilter } from "../../utils/audioActions";
import { audioNotes } from "../RecordingFeatures/AudioNote";
import { useTrackNavigation } from "../../utils/trackNavigationUtils";
import "../../css/app/recordingList.css";

const AudioFile = ({
    setNoFolderAudioData,
    handleGetFilterAudioRecording,
    dohandalMergeSelectAudio,
    actionFilter,
    clickedAudios,
    openModal,
    setOpenModal,
    setOpenRenameModal,
    setOpenMoveToFolderModal,
    setIsMoveToFolder,
    folders,
    setFolders,


}) => {


    const {
        tabIndex,
        setAudio,
        setSelectedConvertAudio,
        setSelectedTranscriptAudio,
        setSelectedTrimAudio,
        setSelectedAdjustAudio,
        selectedTrimAudio,
        selectedAdjustAudio,
        setAudioData,
        audioData,
        selectMergeAudio,
        audioIndex,
        setAudioIndex,
        openDropdownId,
        setOpenDropdownId,
        audioReName,
        setAudioReName,
        initialAudioName,
        setInitialAudioName,
        selectedTranscriptAudio,
        setSelectedAudioId,
        selectedAudioId,
        selectedFolderId,
        setSelectedFolderId,
        textAreaContent,
        setTextAreaContent,
        isUpdateTranscribe,
        setIsUpdateTranscribe,
        filterAudioData,
        setFilterAudioData,
        currentAudioId,
        setCurrentAudioId,
        favoriteAudio,
        setFavoriteAudio,
        listTabIndex,
        actionTabIndex,
        setActionTabIndex,
        showModal, setShowModal,
        modalMessage, setModalMessage,
        actionType,
        pendingIndex,
        setPendingIndex,
        audio,
        isAudioPlaying

    } = useContext(SidebarContext);
    const { isPrevDisabled, isNextDisabled, playPreviousTrack, playNextTrack, handleUnsupportedFile } = useTrackNavigation()

    const [dropdownPosition, setDropdownPosition] = useState('bottom');
    // const [showModal, setShowModal] = useState(false);
    // const [modalMessage, setModalMessage] = useState("");

    const dropdownRef = useRef(null);

    const selectedMergeAudio = selectMergeAudio.map(e => e._id);


    const handleClose = () => {
        setOpenModal(false);
        setAudioReName("");
    };

    const doHandlerplayAudioUrl = (audioElement, index) => {

        // Check if the audio file has a CAF format
        const fileExtension = audioElement?.audio?.fileName.split('.').pop().toLowerCase();
        if (fileExtension === "caf") {
            // Show modal with a warning message
            setModalMessage("This audio format works best in our mobile apps. Download our iOS or Android app to play this file.");
            setShowModal(true);
            setAudioIndex(0);
            setAudio("");
        }
        else if (fileExtension === "m4a") {
            // Show modal with a warning message
            setModalMessage("This audio format works best in our mobile apps. Download our iOS or Android app to play this file.");
            setShowModal(true);
            setAudioIndex(0);
            setAudio("");
        }
        else {
            // Set the audio and index to play
            setAudioIndex(index);
            setAudio(audioElement);
            // console.log("Playing audio...");
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setModalMessage("");


    };


    const handleFunctionality = () => {
        if (pendingIndex !== null) {
            setAudioIndex(pendingIndex); // Set the pending index as the current index
            const list = listTabIndex === 1 ? filterAudioData : favoriteAudio;
            const fileExtension = list[pendingIndex]?.audio?.fileName.split('.').pop().toLowerCase();

            // Check if the next track is unsupported
            if (fileExtension === "caf" || fileExtension === "m4a") {
                handleUnsupportedFile(); // Reopen modal for unsupported format
                setPendingIndex(actionType === "next" ? pendingIndex + 1 : pendingIndex - 1); // Update pending index
                return;
            }
            if (fileExtension == undefined) {
                setActionTabIndex(null);

            }
            setPendingIndex(null);
        }

        setShowModal(false);
        setModalMessage("");

    }
    const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
    };

    const convertBytesToKB = (bytes) => {
        const kb = bytes / 1024;
        return kb.toFixed(2);
    };

    const handleDeleteAudioRecording = async (e, id) => {
        e.preventDefault();
        try {
            const data = await AudioHandler.doDeleteRecording(id);
            if (data?.statusCode === 200) {
                successToast(data.message);
                setAudio('')
                setFilterAudioData((prevAudioData) =>
                    prevAudioData.filter((audio) => audio._id !== id)
                )

                setFavoriteAudio((prevAudioData) =>
                    prevAudioData.filter((audio) => audio._id !== id)
                )
            } else {
                // Handle non-200 responses
                const errorMessage =
                    data?.response?.data?.message || data.message || "An error occurred";
                console.log(errorMessage);
                errorToast(errorMessage);
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message || error.message || "An error occurred";
            console.log(errorMessage);
            errorToast(errorMessage);
        }
    };

    const handleFavoriteAudioRecording = async (e, id, isFavorite) => {
        e.preventDefault();
        setOpenDropdownId(null)
        try {
            const payload = {
                isFavourite: isFavorite,
            };
            const data = await AudioHandler.doUpdateRecording(id, payload);
            if (data.statusCode === 200) {
                if (isFavorite) {
                    successToast("Added to Favourite");
                } else {
                    successToast("Removed from Favourite");
                }
                setFilterAudioData((prevAllAudioData) =>
                    prevAllAudioData.map((audio) =>
                        audio._id === id ? { ...audio, isFavourite: isFavorite } : audio
                    )
                );
                if (!isFavorite && listTabIndex === 2) {
                    setFavoriteAudio((prevAudioData) =>
                        prevAudioData.filter((audio) => audio._id !== id)
                    );
                }
            } else {
                const errorMessage =
                    data?.response?.data?.message || data.message || "An error occurred";
                console.log(errorMessage);
                errorToast(errorMessage);
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message || error.message || "An error occurred";
            console.log(errorMessage);
            errorToast(errorMessage);
        }
    };


    const formatFileSize = (bytes) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };


    useEffect(() => {
        // Function to handle closing dropdown on click outside
        const handleOutsideClick = (event) => {
            if (!event.target.closest('.dropdown')) {
                setOpenDropdownId(null); // Close the dropdown when clicking outside
            }
        };

        // Attach click event listener to document
        document.addEventListener('click', handleOutsideClick);

        // Clean up event listener on component unmount
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);




    const toggleDropdown = (e, id) => {
        e.stopPropagation();
        // Check if there is enough space below the button
        const buttonRect = e.currentTarget.getBoundingClientRect();
        const dropdownHeight = dropdownRef.current ? dropdownRef.current.offsetHeight : 395;
        const viewportHeight = window.innerHeight;
        if (buttonRect.bottom + dropdownHeight > viewportHeight) {
            setDropdownPosition('top');
        } else {
            setDropdownPosition('bottom');
        }
        if (openDropdownId === id) {
            setOpenDropdownId(null);
        } else {
            setOpenDropdownId(id);


        }
    };

    const handleCopyAudio = async (id, folderId) => {
        try {
            const data = await AudioHandler.doHandalCopyAudio(id, folderId)
            // console.log(data, 'copy response')
            if (data?.statusCode === 200) {
                const copiedAudio = { ...data?.data, isFavourite: false }; // Set isFavourite to false for the copied audio

                setFilterAudioData(prevAudioData => {
                    const updatedAudioData = [copiedAudio, ...prevAudioData]; // Add the copied audio to the beginning of the audioData array
                    return updatedAudioData;
                });
                setAudio('')
                successToast(data?.message)
            } else {
                const errorMessage =
                    data?.response?.data?.message || data?.message || "An error occurred";
                console.log(errorMessage);
                errorToast(errorMessage);
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message || error.message || "An error occurred";
            console.log(errorMessage);
            errorToast(errorMessage);
        }
    }




    const fetchFileAsBlob = async (url) => {
        try {
            // console.log(url, 'url')
            const response = await fetch(url, { mode: 'no-cors' });
            const blob = await response.blob();
            // console.log(blob, 'blob')
            return blob;
        } catch (error) {
            console.error('Error fetching the file as Blob:', error);
            return null;
        }
    };


    // Paython
    // const doHandleTranscribeAudio = async () => {
    //     if (!selectedTranscriptAudio?.audio?.url) {
    //         return;
    //     }

    //     try {
    //         // Step 1: Fetch the audio file as Blob
    //         const audioUrl = selectedTranscriptAudio?.audio?.url;
    //         const audioName = selectedTranscriptAudio?.audio?.fileName
    //         const fileBlob = await fetchFileAsBlob(audioUrl);

    //         if (!fileBlob) {
    //             console.error('File could not be fetched as Blob.');
    //             return;
    //         }
    //         // Step 2: Prepare FormData and append the Blob
    //         const formData = new FormData();
    //         formData.append('file', fileBlob, audioName);  // Specify file name and extension

    //         // Step 3: Call the API to send the formData
    //         const responseData = await AudioHandler.doHandalGetTranscribeAudioData(formData);
    //         // Step 4: Handle the response
    //         if (responseData?.status === 200) {
    //             console.log('Transcription successful:', responseData);
    //             setTextAreaContent(responseData?.data)
    //             setIsUpdateTranscribe(true)


    //         } else {
    //             console.error('Error in transcription:', responseData);
    //         }

    //     } catch (error) {
    //         console.error('Error handling transcription:', error);
    //     }
    // };


    const doHandleVerifyTranscribeAudioData = (el) => {
        const checkTranscribeStatus = el?.transcribe?.isTranscribe
        // console.log(checkTranscribeStatus)
        if (checkTranscribeStatus == false || checkTranscribeStatus == undefined) {
            setActionTabIndex(null);
            setAudio(el)

        } else {
            setTextAreaContent(el?.transcribe?.transcribeText)
        }
    };



    const handleMoveToHome = async (e, audioid, folderid) => {
        e.preventDefault()
        try {
            const payload = {
                audioId: audioid,
                folderId: folderid,
                isFolder: false
            };
            const data = await AudioHandler.doMoveToHomeAudio(payload)

            if (data?.statusCode === 200) {
                // Remove the moved audio from the folder's audio data
                setFilterAudioData(prevAudioData => {
                    const updatedAudioData = prevAudioData.filter(audio => audio._id !== audioid);
                    return updatedAudioData;
                });
                setFavoriteAudio(prevAudioData => {
                    const updatedAudioData = prevAudioData.filter(audio => audio._id !== audioid);
                    return updatedAudioData;
                });
            }
        } catch (error) {
            console.log(error)
        }
    }

    const getAudioImageSrc = (action) => {
        switch (action) {
            case 'Merge':
                return '/img/dashboard/Merge.png'; // path for merge icon
            case 'Convert':
                return '/img/dashboard/Convert.png'; // path for convert icon
            case 'Transcribe':
                return '/img/dashboard/Transcribe.png'; // path for transcript icon
            case 'Trim':
                return '/img/dashboard/Trim.png';
            case 'SpeedController':
                return '/img/dashboard/Adjust.svg';
            case 'Audio':
            default:
                return '/img/dashboard/audio.png'; // default audio icon
        }
    };

    // Lucide icon + tone for each list icon variant
    const audioIconMap = {
        '/img/dashboard/Merge.png': { icon: 'lucide:merge', tone: '' },
        '/img/dashboard/Convert.png': { icon: 'lucide:repeat-2', tone: '' },
        '/img/dashboard/Transcribe.png': { img: '/img/dashboard/Transcribe.png', tone: 'vr-tone-indigo' },
        '/img/dashboard/Trim.png': { icon: 'lucide:scissors', tone: 'vr-tone-cyan' },
        '/img/dashboard/Adjust.svg': { icon: 'lucide:sliders-horizontal', tone: 'vr-tone-blue' },
        '/img/dashboard/audio.png': { icon: 'lucide:audio-lines', tone: '' },
    };

    return (
        <div className="vr-rl-list vr-stagger">
            {
                Array.isArray(listTabIndex === 1 ? filterAudioData : favoriteAudio) && (listTabIndex === 1 ? filterAudioData : favoriteAudio).map((el, index) => {

                    // Hidden rather than removed, so index still points into the full list for playback.
                    if (!matchesActionFilter(el, actionFilter)) {
                        return null;
                    }
                    const fileName = el?.audio?.fileName;
                    const extension = fileName?.includes('.')
                        ? fileName.slice(fileName?.lastIndexOf('.') + 1)
                        : '';
                    const isActiveAudio = !!el?._id && audio?._id === el._id;
                    const rowIcon = audioIconMap[getAudioImageSrc(el?.audio?.lastActionPerformed)] || audioIconMap['/img/dashboard/audio.png'];
                    return (
                        <div
                            key={el._id}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => { if (e.target === e.currentTarget && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); e.currentTarget.click(); } }}
                            className={`vr-rl-row${isActiveAudio ? " audio-row-active is-active" : ""}${actionTabIndex == 4 && selectedMergeAudio.includes(el._id) ? " is-picked" : ""}${openDropdownId === el._id ? " is-menu-open" : ""}`}
                            aria-current={isActiveAudio ? "true" : undefined}
                            onClick={(e) => {
                                const fileExtension = el?.audio?.fileName.split('.').pop().toLowerCase();
                                if (fileExtension === "caf" || fileExtension === "m4a") {
                                    // Show modal with a warning message
                                    setModalMessage("This audio format works best in our mobile apps. Download our iOS or Android app to play this file.");
                                    setShowModal(true);
                                    // setAudioIndex(0);
                                    // setAudio("");
                                    return
                                }
                                doHandlerplayAudioUrl(el, index);

                                // Picking another recording while a tool is open leaves the tool for that recording's player; buttons inside the row (merge Add) keep working.
                                if (actionTabIndex && !e.target.closest("button")) {
                                    if (selectedTrimAudio?.isLocalUpload) {
                                        URL.revokeObjectURL(selectedTrimAudio?.audio?.url);
                                        setSelectedTrimAudio([]);
                                    }
                                    if (selectedAdjustAudio?.isLocalUpload) {
                                        URL.revokeObjectURL(selectedAdjustAudio?.audio?.url);
                                        setSelectedAdjustAudio([]);
                                    }
                                    if (tabIndex == 2) {
                                        setSelectedAudioId(el?._id);
                                    }
                                    setActionTabIndex(null);
                                    return;
                                }

                                if (tabIndex == 2 || actionTabIndex == 5) {
                                    setSelectedAudioId(el?._id);
                                }
                                if (actionTabIndex == 4) {
                                    setSelectedAudioId(null)
                                }
                                if (actionTabIndex == 3) {

                                    setSelectedTrimAudio(el);
                                } else if (actionTabIndex == 5) {


                                    setSelectedConvertAudio(el);
                                } else if (actionTabIndex == 6) {
                                    setSelectedTranscriptAudio(el);
                                    doHandleVerifyTranscribeAudioData(el)
                                } else if (actionTabIndex == 7) {
                                    setSelectedAdjustAudio(el);
                                }

                            }}
                        >
                            <div className="vr-rl-main">

                                <span className={`vr-rl-icon ${rowIcon.tone}${rowIcon.img ? " has-img" : ""}`}>
                                    {rowIcon.img ? <img src={rowIcon.img} alt="" /> : <Icon icon={rowIcon.icon} width="20" height="20" />}
                                </span>

                                <div className="vr-rl-text">
                                    <span className="vr-rl-name-line"  >
                                        {tabIndex == 2 ? (<span className="audioname vr-rl-name">{el?.audio?.fileName}</span>
                                        ) : (<span className="audioname vr-rl-name">{el?.audio?.fileName}</span>
                                        )}
                                        {isActiveAudio && (
                                            <span
                                                className={`now-playing-bars vr-rl-eq${isAudioPlaying ? "" : " is-paused"}`}
                                                title={isAudioPlaying ? "Now playing" : "Paused"}
                                                aria-label={isAudioPlaying ? "Now playing" : "Paused"}
                                            >
                                                <span></span>
                                                <span></span>
                                                <span></span>
                                            </span>
                                        )}
                                    </span>
                                    <div className="vr-rl-meta">
                                        <p className="vr-rl-dur">
                                            {formatTimeWithOptionalHours(durationToSeconds(el?.audio?.timeDuration))}
                                        </p>
                                        <p className="vr-rl-ext">

                                            {extension}
                                        </p>
                                        {el?.isFavourite ? (
                                            <Icon
                                                icon="mdi:heart"
                                                className="vr-rl-fav"
                                                aria-label="Favorite"
                                            />
                                        ) : null}
                                        {audioNotes(el).length ? (
                                            <Icon
                                                icon="lucide:sticky-note"
                                                className="vr-rl-hasnote"
                                                aria-label="Has notes"
                                            />
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="vr-rl-side">
                                {actionTabIndex != 6 && actionTabIndex != 7 && tabIndex != 1 && actionTabIndex != 3 && actionTabIndex != 4 && actionTabIndex != 5 && (
                                    <div className="d-flex dropdown-container vr-rl-sidein" >
                                        <div className="vr-rl-when">
                                            <p>
                                                <span className="vr-rl-date">{moment(el?.createdAt).format("DD-MM-YYYY")}</span>
                                                <span className="vr-rl-time">{moment(el?.createdAt).format("hh:mm A")}</span>
                                            </p>
                                            <span className="vr-rl-size">{formatFileSize(el?.audio?.fileSize)}</span>
                                        </div>
                                        <div className="dropdown"
                                        >
                                            <button
                                                type="button"
                                                aria-label="Recording options"
                                                className="dropdown-toggle vr-rl-more"
                                                aria-expanded={openDropdownId === el?._id}
                                                onClick={(e) => toggleDropdown(e, el?._id)}


                                            >
                                                <Icon icon="lucide:more-horizontal" width="18" height="18" />
                                            </button>
                                            {openDropdownId === el._id && (
                                                <ul
                                                    ref={dropdownRef}
                                                    className={`dropdown-menu vr-rl-menu vr-rl-rowmenu ${dropdownPosition === 'top' ? 'top' : ''} ${openDropdownId === el?._id ? 'show' : ''}`}
                                                    style={{
                                                        display: openDropdownId === el?._id ? 'block' : 'none',
                                                    }}
                                                    onClick={(e) => e.stopPropagation()}
                                                >
                                                    <li
                                                        className="vr-rl-menu-item"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setCurrentAudioId(el?._id);
                                                            setOpenRenameModal(true);
                                                            setOpenDropdownId(null)
                                                            const reNamefileName = el?.audio?.fileName
                                                            const parts = reNamefileName?.split('.');
                                                            setAudioReName(parts[0]);
                                                            setInitialAudioName(parts[0])

                                                        }}
                                                    >
                                                        <Icon icon="lucide:pencil" className="vr-rl-menu-icon" />
                                                        <a
                                                            className="vr-rl-menu-label"
                                                            href=""
                                                        >
                                                            Rename
                                                        </a>
                                                    </li>

                                                    <li
                                                        className="vr-rl-menu-item"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setOpenDropdownId(null)
                                                            console.log(el, 'el')
                                                            handleCopyAudio(el?._id, el?.audio?.folderId || el?.folderId ? el?.audio?.folderId || el?.folderId : '')
                                                        }}
                                                    >
                                                        <Icon icon="lucide:copy" className="vr-rl-menu-icon" />
                                                        <a
                                                            className="vr-rl-menu-label"
                                                            href=""
                                                        >
                                                            Duplicate
                                                        </a>
                                                    </li>

                                                    <li
                                                        className="vr-rl-menu-item"
                                                        onClick={(e) =>
                                                            handleFavoriteAudioRecording(
                                                                e,
                                                                el._id,
                                                                !el.isFavourite
                                                            )
                                                        }
                                                    >
                                                        {el.isFavourite ? (
                                                            <>
                                                                <Icon
                                                                    icon="mdi:heart"
                                                                    className="vr-rl-menu-icon is-fav"
                                                                />
                                                                <a
                                                                    className="vr-rl-menu-label"
                                                                    href=""
                                                                >
                                                                    Remove From Favorite
                                                                </a>
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Icon icon="lucide:heart" className="vr-rl-menu-icon" />
                                                                <a
                                                                    className="vr-rl-menu-label"
                                                                    href=""
                                                                >
                                                                    Add To Favorite
                                                                </a>
                                                            </>
                                                        )}
                                                    </li>

                                                    <li
                                                        className="vr-rl-menu-item"
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setOpenDropdownId(null)
                                                            setCurrentAudioId(el._id);
                                                            setOpenMoveToFolderModal(true)
                                                            setIsMoveToFolder(true)
                                                        }}
                                                    >
                                                        <Icon icon="lucide:folder-input" className="vr-rl-menu-icon" />
                                                        <a
                                                            className="vr-rl-menu-label"
                                                            href=""
                                                        >
                                                            Move To Folder
                                                        </a>
                                                    </li>

                                                    {tabIndex != 2 && (
                                                        <li
                                                            className="vr-rl-menu-item"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setOpenDropdownId(null); // Close dropdown
                                                                setCurrentAudioId(el?._id);
                                                                handleMoveToHome(e, el?._id, el?.folderId)
                                                            }}
                                                        >
                                                            <Icon icon="lucide:house" className="vr-rl-menu-icon" />
                                                            <a
                                                                className="vr-rl-menu-label"
                                                                href=""
                                                            >
                                                                Move To Home
                                                            </a>
                                                        </li>
                                                    )}

                                                    <li
                                                        className="vr-rl-menu-item is-danger"
                                                        onClick={(e) => {
                                                            handleDeleteAudioRecording(e, el._id);
                                                            setOpenDropdownId(null)

                                                        }}
                                                    >
                                                        <Icon icon="lucide:trash-2" className="vr-rl-menu-icon" />
                                                        <a
                                                            className="vr-rl-menu-label"
                                                            href=""
                                                        >
                                                            Delete
                                                        </a>
                                                    </li>
                                                </ul>
                                            )}

                                        </div>
                                    </div>
                                )}
                                {actionTabIndex == 4 && (
                                    <div>
                                        {selectedMergeAudio.includes(el._id) ? (
                                            <button
                                                className="vr-rl-pick is-added"
                                                onClick={() => dohandalMergeSelectAudio(el)}
                                            >
                                                <Icon icon="lucide:check" width="14" height="14" />
                                                <span>Added</span>
                                            </button>
                                        ) : (
                                            <button
                                                className="vr-rl-pick"
                                                onClick={() => dohandalMergeSelectAudio(el)}
                                            >
                                                <Icon icon="lucide:plus" width="14" height="14" />
                                                <span>Add</span>
                                            </button>
                                        )}
                                    </div>
                                )}

                                {(actionTabIndex == 3 || actionTabIndex == 5 || actionTabIndex == 6 || actionTabIndex == 7) && (
                                    <div className="d-flex">
                                        <div className="vr-rl-when">
                                            <p>
                                                <span className="vr-rl-date">{moment(el?.createdAt).format("DD-MM-YYYY")}</span>
                                                <span className="vr-rl-time">{moment(el?.createdAt).format("hh:mm A")}</span>
                                            </p>
                                            <span className="vr-rl-size">{formatFileSize(el?.audio?.fileSize)}</span>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
            {showModal &&
                <Modal
                    // onClose={(e) => closeModal()}
                    modaltxt={"Format Not Supported on Web"}
                    btnnone
                >
                    <div className="vr-rl-form" >
                        <div className="vr-rl-confirm is-info">
                            <span className="vr-rl-confirm-icon"><Icon icon="lucide:smartphone" width="20" height="20" /></span>
                            <p>{modalMessage}</p>
                        </div>
                        <div className="vr-rl-btnrow">

                            <button className="vr-btn vr-btn-primary vr-btn-lg vr-btn-block" onClick={() => {
                                window.open("https://voicememo.co/#download")
                                handleFunctionality()
                            }
                            }>Get Mobile App</button>
                            <button className="vr-btn vr-btn-secondary vr-btn-lg vr-btn-block" onClick={() => {
                                handleFunctionality()
                            }
                            }>OK</button>
                        </div>
                    </div>

                </Modal>
            }
        </div >
    );
};

export default AudioFile;
